import axios from 'axios';

/**
 * Resolves a file path to a full URL.
 * Handles both local relative paths and full S3 URLs.
 */
export const getFileUrl = (path) => {
  if (!path) return '';
  if (typeof path !== 'string') return '';
  
  const trimmedPath = path.trim();

  // If it's already a full URL (starts with http:// or https://)
  // We use a regex to be more robust against leading slashes or case issues
  if (/^https?:\/\//i.test(trimmedPath)) {
    return trimmedPath;
  }

  // If the path starts with a slash, we remove it to avoid double slashes when prepending baseURL
  const normalizedPath = trimmedPath.startsWith('/') ? trimmedPath.substring(1) : trimmedPath;

  // Re-check after removing leading slash (in case it was /https://...)
  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }
  
  // Special check for common S3 patterns if regex failed for some reason
  if (normalizedPath.includes('.amazonaws.com/') || normalizedPath.includes('X-Amz-Algorithm')) {
    return normalizedPath;
  }

  // Otherwise, prepend the base API URL (Local storage)
  let baseUrl = axios.defaults.baseURL || '';
  if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }

  return `${baseUrl}/${normalizedPath}`;
};